import { render, staticRenderFns } from "./ShareToEditList.vue?vue&type=template&id=618188d1&scoped=true"
import script from "./ShareToEditList.vue?vue&type=script&lang=js"
export * from "./ShareToEditList.vue?vue&type=script&lang=js"
import style0 from "./ShareToEditList.vue?vue&type=style&index=0&id=618188d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618188d1",
  null
  
)

export default component.exports